<template>
    <a class='list__result' :href='url'>
        <div class='container'>
            <div class='row offset--md-4 offset--lg-3'>

                <div class='col--sm-third col--md-2 col--lg-1 gutter--sm gutter--md-none'>
                    <div class='winners__headshot circular'>
                        <img :src='headshot' alt=''>
                    </div>
                </div>

                <div class='col--sm-2-thirds col--md-8 offset--md-1 justify--center'>
                    <h4 class='size--5' v-if='region'>{{ region }}</h4>
                    <h3 class='size--2 bold'>{{ name }}</h3>
                    <div class='size--2' v-html='description'></div>
                </div>

            </div>
        </div>
    </a>
</template>

<script>
import headshotPlaceholder from '~/img/headshot-placeholder.svg';

export default {
    data () {
        return {
            url: this.result.url,
            headshot: (this.result.headshot) ? this.result.headshot.thumbnail_url : headshotPlaceholder,
            region: (this.result.region) ? this.result.region.title : false,
            name: this.result.title,
            description: this.result.short_description
        }
    },

    props: ['result']
}
</script>



// WEBPACK FOOTER //
// assets/js/thelist/components/Result.vue